"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatesFromTimeSpan = exports.DateRangeType = void 0;
const tslib_1 = require("tslib");
const database_types_1 = require("@acumen/database-types");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const moment_1 = tslib_1.__importDefault(require("moment"));
var DateRangeType;
(function (DateRangeType) {
    DateRangeType["LastDay"] = "LastDay";
    DateRangeType["Last3Days"] = "Last3Days";
    DateRangeType["LastWeek"] = "LastWeek";
    DateRangeType["Last2Weeks"] = "Last2Weeks";
    DateRangeType["LastMonth"] = "LastMonth";
    DateRangeType["Last3Months"] = "Last3Months";
    DateRangeType["Last6Months"] = "Last6Months";
    DateRangeType["LastYear"] = "LastYear";
    DateRangeType["Last2Years"] = "Last2Years";
    DateRangeType["Last3Years"] = "Last3Years";
})(DateRangeType = exports.DateRangeType || (exports.DateRangeType = {}));
const timeSpanSubtraction = {
    [DateRangeType.LastDay]: {
        count: 1,
        unit: "day",
    },
    [DateRangeType.Last3Days]: {
        count: 3,
        unit: "day",
    },
    [DateRangeType.LastWeek]: {
        count: 1,
        unit: "week",
    },
    [DateRangeType.Last2Weeks]: {
        count: 2,
        unit: "week",
    },
    [DateRangeType.LastMonth]: {
        count: 1,
        unit: "month",
    },
    [DateRangeType.Last3Months]: {
        count: 3,
        unit: "month",
    },
    [DateRangeType.Last6Months]: {
        count: 6,
        unit: "month",
    },
    [DateRangeType.LastYear]: {
        count: 12,
        unit: "month",
    },
    [DateRangeType.Last2Years]: {
        count: 24,
        unit: "month",
    },
    [DateRangeType.Last3Years]: {
        count: 36,
        unit: "month",
    }
};
exports.getDatesFromTimeSpan = (selectedTimeSpan, timezone, metricInterval) => {
    const interval = (lodash_1.default.includes([database_types_1.MetricInterval.DAY, database_types_1.MetricInterval.WEEK, database_types_1.MetricInterval.MONTH], metricInterval)) ?
        metricInterval :
        database_types_1.MetricInterval.DAY;
    const now = new Date();
    const endOfPeriodTime = moment_1.default.tz(now, timezone).subtract(1, "d").endOf("day");
    const timeSpan = timeSpanSubtraction[selectedTimeSpan] || timeSpanSubtraction.Last6Months;
    const startOfPeriodTime = moment_1.default.tz(now, timezone)
        .subtract(timeSpan.count, timeSpan.unit)
        // Note: sets Monday as the start of the week to be synced with the periods in the metrics response
        .startOf(interval === "week" ? "isoWeek" : interval)
        .startOf("day");
    return {
        endTime: endOfPeriodTime.toDate(),
        startTime: startOfPeriodTime.toDate()
    };
};
//# sourceMappingURL=date-range.js.map